import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Fingerprint, X } from "lucide-react";

const KEY = "zeeptel_callerid_nudge_dismissed";

export const CallerIdNudge = ({ user }) => {
  const [hidden, setHidden] = useState(() => localStorage.getItem(KEY) === "1");
  if (hidden || !user || user.own_caller_id?.verified) return null;
  const dismiss = () => { localStorage.setItem(KEY, "1"); setHidden(true); };
  return (
    <div className="mb-4 rounded-2xl border border-primary/20 bg-primary/5 p-4 flex items-start gap-3" data-testid="callerid-nudge">
      <div className="h-9 w-9 rounded-full bg-white text-primary flex items-center justify-center shrink-0 shadow-sm">
        <Fingerprint className="h-4 w-4" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-heading font-bold text-sm text-zinc-900">Let them see it&rsquo;s you calling</div>
        <p className="text-xs text-zinc-600 mt-0.5 leading-relaxed">
          Verify your mobile once (30 seconds) and the people you call abroad will see your own number and can call you back.
        </p>
        <Link to="/settings" data-testid="callerid-nudge-link" className="inline-block mt-2 text-xs font-bold text-primary underline">
          Verify my number
        </Link>
      </div>
      <button onClick={dismiss} data-testid="callerid-nudge-dismiss" aria-label="Dismiss"
        className="h-7 w-7 rounded-full text-zinc-400 hover:text-zinc-700 flex items-center justify-center shrink-0">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
